import {
  getV1CompaniesCompanyIdMaterialTypeahead,
  GetV1CompaniesCompanyIdMaterialTypeaheadData,
  getV1CompaniesCompanyIdOrdersOrderIdMaterialsTypeahead,
  Material_Read_Typeahead,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { MaterialTypeahead } from '~hooks/useMaterials/models';

import MaterialOptionSecondary from '../Parts/MaterialOptionSecondary';
import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import {
  CommonAsyncAutocompleteFieldProps,
  FetchFnQueryArgument,
} from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Material_Read_Typeahead,
  MaterialTypeahead,
  GetV1CompaniesCompanyIdMaterialTypeaheadData
> & { companyId: string; orderId?: string | null };

export default function AutocompleteMaterialsTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  orderId,
  ...rest
}: Props<T>) {
  const parseFn = (item: Material_Read_Typeahead) => {
    const parsed = MaterialTypeahead.parse(item);

    return { _entity: parsed, label: parsed.name, value: parsed.id };
  };
  const renderSecondary = (
    option: { _entity: MaterialTypeahead },
    inputValue: string,
  ) => <MaterialOptionSecondary material={option._entity} query={inputValue} />;

  const fetchFn = {
    arguments: { companyId, orderId },
    request: ({
      companyId: requestCompanyId,
      orderId: requestOrderId,
      query,
      signal,
    }: {
      companyId: string;
      orderId?: string | null;
      query: FetchFnQueryArgument;
      signal: AbortSignal;
    }) =>
      requestOrderId
        ? getV1CompaniesCompanyIdOrdersOrderIdMaterialsTypeahead({
            path: { 'company-id': requestCompanyId, 'order-id': requestOrderId },
            query,
            signal,
          })
        : getV1CompaniesCompanyIdMaterialTypeahead({
            path: { 'company-id': requestCompanyId },
            query,
            signal,
          }),
  };

  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName={`AutocompleteMaterialsTypeahead_${companyId}${orderId ? `_${orderId}` : ''}`}
      fetchFn={fetchFn}
      parseFn={parseFn}
      renderSecondary={renderSecondary}
    />
  );
}
